import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";

export class VideoEmbeddedEndedEvent extends BaseAnalyticsEvent {
  videoId: String;
  gameId: Number;
  status: Number;

  constructor(params) {
    super('ended', 'match-video', 'game-center');

    this.videoId = params.videoId;
    this.gameId = params.gameId;
    this.status = params.status;
  }

  get properties() {
    const properties = super.properties;

    properties.videoId = this.videoId;
    properties.gameId = this.gameId;
    properties.status = this.status;

    return properties;
  }
}